import { DeliveryOptionType } from "@jti/store";
import { getExternalShippingCarrierMagentoAddress } from "../getExternalShippingCarrierMagentoAddress";
import { getInStoreDeliveryMagentoAddress } from "../getInStoreDeliveryMagentoAddress";
export const getSelectedShippingAddress = ({ deliveryOptionType, atHomeDeliveryShippingAddress, inStoreDeliveryStore, externalShippingCarrier, }) => {
    if (deliveryOptionType === DeliveryOptionType.AtHome) {
        return atHomeDeliveryShippingAddress;
    }
    if (deliveryOptionType === DeliveryOptionType.InStoreJti && !!inStoreDeliveryStore) {
        return getInStoreDeliveryMagentoAddress(inStoreDeliveryStore);
    }
    if (deliveryOptionType === DeliveryOptionType.CustomDeliveryOption && externalShippingCarrier?.address) {
        return getExternalShippingCarrierMagentoAddress(externalShippingCarrier.address);
    }
    return undefined;
};
//# sourceMappingURL=getSelectedShippingAddress.js.map